import {AutoLayoutSnackbarStatusKey} from "@buildwithflux/models";

import {AgentDisplayStatus} from "./ProjectDataEnrichmentService";

export type AgentStatusIconType = "loading" | "check" | "pause" | "play" | "copilot" | "error";

export interface AgentStatusConfig {
    text: string;
    iconType: AgentStatusIconType;
}

export const AGENT_STATUS_CONFIG: Record<AgentDisplayStatus, AgentStatusConfig> = {
    [AgentDisplayStatus.AutoLayoutInitializing]: {
        text: "Initializing...",
        iconType: "loading",
    },
    [AgentDisplayStatus.AutoLayoutRouting]: {
        text: "Routing...",
        iconType: "loading",
    },
    [AgentDisplayStatus.AutoLayoutPaused]: {
        text: "Auto-Layout paused.",
        iconType: "pause",
    },
    [AgentDisplayStatus.AutoLayoutResuming]: {
        text: "Resuming...",
        iconType: "loading",
    },
    [AgentDisplayStatus.AutoLayoutComplete]: {
        text: "Auto-Layout is complete.",
        iconType: "check",
    },
    [AgentDisplayStatus.AutoLayoutFailed]: {
        text: "Auto-Layout failed.",
        iconType: "error",
    },
    [AgentDisplayStatus.AutopilotCreatingPlan]: {
        text: "Creating plan...",
        iconType: "loading",
    },
    [AgentDisplayStatus.AutopilotUpdatingPlan]: {
        text: "Updating plan...",
        iconType: "loading",
    },
    [AgentDisplayStatus.AutopilotProcessing]: {
        text: "Processing...",
        iconType: "loading",
    },
    [AgentDisplayStatus.AutopilotReadyToExecute]: {
        text: "Ready to start.",
        iconType: "play",
    },
    [AgentDisplayStatus.AutopilotWorking]: {
        text: "Working...",
        iconType: "loading",
    },
    [AgentDisplayStatus.AutopilotCompleted]: {
        text: "Plan completed.",
        iconType: "check",
    },
    [AgentDisplayStatus.AutopilotAmbiguous]: {
        text: "Needs more info.",
        iconType: "copilot",
    },
    [AgentDisplayStatus.AutopilotWaitingForInput]: {
        text: "Waiting for your input...",
        iconType: "pause",
    },
    [AgentDisplayStatus.AutopilotImpossible]: {
        text: "Cannot run plan.",
        iconType: "copilot",
    },
    [AgentDisplayStatus.AutopilotFailed]: {
        text: "Stopped.",
        iconType: "copilot",
    },
    [AgentDisplayStatus.AutopilotStopping]: {
        text: "Stopping...",
        iconType: "loading",
    },
};

/**
 * Maps an AgentDisplayStatus to its corresponding AutoLayoutSnackbarStatusKey.
 * Returns null if the status is not an auto-layout status or doesn't have a dismissal key.
 *
 * @param status - The agent display status to map
 * @returns The corresponding snackbar status key, or null if not applicable
 */
export function getSnackbarStatusKeyFromAgentStatus(status: AgentDisplayStatus): AutoLayoutSnackbarStatusKey | null {
    switch (status) {
        case AgentDisplayStatus.AutoLayoutRouting:
            return "routing";
        case AgentDisplayStatus.AutoLayoutPaused:
            return "paused";
        case AgentDisplayStatus.AutoLayoutComplete:
            return "complete";
        case AgentDisplayStatus.AutoLayoutFailed:
            return "failed";
        default:
            return null;
    }
}
